import app_process_img from "../Assets/img/app_process.png";
import vector_img from '../Assets/img/illustrastions/vector-1.png'
import React from "react";
import {AppProcessForDrivers, AppProcessForPassengers} from "../Assets/StaticContents/AppProcessContent";

const AppProcessDiv = ({content}) => {
    return (
        <div  className="pb-4 md:pb-8 lg:pb-12">
            <div
                className={`${content.isFirstDiv ? 'md:flex md:justify-end' : ''} py-4`}
                dangerouslySetInnerHTML={{ __html: content.svg }}
            />
            <div className={`${content.isFirstDiv ? 'md:flex md:justify-end' : ''} py-4`}>
                <h3 className="text-lg font-semibold">{content.title}</h3>
            </div>
            <div className={`${content.isFirstDiv ? 'md:text-right' : ''}`}>
                {content.text}
            </div>
        </div>
    )
}

const AppProcessSection = ({appType}) => {
    const app_process_lists = appType ? AppProcessForDrivers : AppProcessForPassengers
    return (
        <div className="mt-8 flex flex-wrap w-full items-start md:justify-between">
            <div className="relative bg-white flex sm:w-1/2 lg:w-1/4">
                <div data-aos-delay="300" data-aos="fade-right" className="flex flex-col px-2 md:py-8 text-gray-700">
                    <AppProcessDiv content={app_process_lists[0]} />
                    <AppProcessDiv content={app_process_lists[1]} />
                </div>
            </div>
            <div data-aos-delay="600" data-aos="fade-up" className="relative bg-white flex-col flex lg:w-2/4 py-8 md:py-0">
                <img className="max-w-full h-auto" src={app_process_img} alt="App Process" loading="lazy" />
            </div>
            <div className="relative bg-white flex flex-col sm:w-1/2 lg:w-1/4">
                <div data-aos-delay="300" data-aos="fade-left" className="flex flex-col px-2 md:py-8">
                    <AppProcessDiv content={app_process_lists[2]} />
                    <AppProcessDiv content={app_process_lists[3]} />
                </div>
            </div>
        </div>
    )
}

const AppProcess = ({appType, setAppType}) => {
    const headingForCarOwner = `Download the Parizzo Car Owner app and set up your account. Earn more money carpooling with verified Passengers while driving to work.`
    const headingForPassenger = `Download the Parizzo Passenger app and set up your account. Enjoy affordable and comfortable ride to work daily`
    return (
        <section className="px-2 sm:px-4 md:px-10 lg:px-16 py-16 relative">
            <img src={vector_img} alt="Vector" className="hidden md:block absolute opacity-80" style={{ top: '-47px', right: '15%' }} />
            <div className="w-full md:max-w-lg lg:max-w-3xl mx-auto text-center py-4 space-y-5 relative z-10">
                <h2 data-aos="fade-up" className="text-lg sm:text-2xl font-semibold uppercase">
                    Discover Parizzo Carpool
                </h2>
                <div data-aos="fade-up" className="text-md text-gray-700 w-full max-w-xl mx-auto text-center">
                    { appType ? headingForCarOwner : headingForPassenger}
                </div>

                <div data-aos="fade-up" className="max-w-xs mx-auto py-4 w-full">
                    <div className="bg-gray-200 p-0.5 flex items-center rounded-md">
                        <button
                            onClick={ () => setAppType(false) }
                            className={`${!appType ? 'bg-green-app text-white' : 'bg-transparent text-gray-500'} py-2.5 w-full  rounded-md focus:outline-none`}>
                            <span className="text-center">Passenger</span>
                        </button>
                        <button
                            onClick={ () => setAppType(true) }
                            className={`${appType ? 'bg-green-app text-white' : 'bg-transparent text-gray-500'} py-2.5 w-full  rounded-md focus:outline-none`}>
                            <span className="text-center">Car Owner</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="lg:px-2">
                <AppProcessSection appType={appType} />
            </div>
        </section>
    )
}

export default AppProcess